module.exports = __webpack_public_path__ + "img/comparison-with-logo.a06354d0.png";